import React from 'react';
import { Paperclip } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { EstadoPagoBadge, formatCurrency, formatDate } from './utils';

export const EstadoCuentaDialog = ({ open, onOpenChange, cliente, estadoCuenta, onVerComprobantes }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-[700px] max-h-[80vh] overflow-y-auto" data-testid="modal-estado-cuenta">
      <DialogHeader>
        <DialogTitle>Estado de Cuenta - {cliente?.nombre}</DialogTitle>
      </DialogHeader>
      {estadoCuenta && (
        <div className="space-y-4 py-4">
          <div className="grid grid-cols-2 gap-4 p-4 bg-accent/40 rounded-lg">
            <div>
              <p className="text-sm text-muted-foreground">Total Facturado</p>
              <p className="text-lg font-display font-700 tabular-nums">
                {formatCurrency(estadoCuenta.resumen.total_facturado)}
              </p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Total Pagado</p>
              <p className="text-lg font-display font-700 text-green-600 tabular-nums">
                {formatCurrency(estadoCuenta.resumen.total_pagado)}
              </p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Saldo Pendiente</p>
              <p className="text-lg font-display font-700 text-red-600 tabular-nums">
                {formatCurrency(estadoCuenta.resumen.total_pendiente)}
              </p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Vencido</p>
              <p className="text-lg font-display font-700 text-red-600 tabular-nums">
                {formatCurrency(estadoCuenta.resumen.total_vencido)}
              </p>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium mb-2">Facturas</h4>
            <div className="border rounded-lg overflow-hidden">
              <table className="w-full text-sm">
                <thead className="bg-muted/50">
                  <tr className="text-left">
                    <th className="p-2 font-medium">Factura</th>
                    <th className="p-2 font-medium">Fecha</th>
                    <th className="p-2 font-medium text-right">Total</th>
                    <th className="p-2 font-medium text-right">Saldo</th>
                    <th className="p-2 font-medium">Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {estadoCuenta.facturas.map((factura) => (
                    <tr key={factura.id || factura._id} className="border-t">
                      <td className="p-2 font-medium">{factura.numero_factura}</td>
                      <td className="p-2">{formatDate(factura.fecha)}</td>
                      <td className="p-2 text-right tabular-nums">{formatCurrency(factura.total_monto)}</td>
                      <td className="p-2 text-right tabular-nums font-medium">
                        {formatCurrency(factura.saldo)}
                      </td>
                      <td className="p-2">
                        <EstadoPagoBadge estado={factura.estado_pago} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {estadoCuenta.pagos.length > 0 && (
            <div>
              <h4 className="text-sm font-medium mb-2">Pagos Realizados</h4>
              <div className="border rounded-lg overflow-hidden">
                <table className="w-full text-sm">
                  <thead className="bg-muted/50">
                    <tr className="text-left">
                      <th className="p-2 font-medium">Fecha</th>
                      <th className="p-2 font-medium">Factura</th>
                      <th className="p-2 font-medium text-right">Monto</th>
                      <th className="p-2 font-medium">Método</th>
                      <th className="p-2 font-medium text-center">Comprob.</th>
                    </tr>
                  </thead>
                  <tbody>
                    {estadoCuenta.pagos.map((pago) => {
                      const compsCount = Array.isArray(pago.comprobantes) ? pago.comprobantes.length : 0;
                      return (
                        <tr key={pago.id || pago._id} className="border-t">
                          <td className="p-2">{formatDate(pago.fecha)}</td>
                          <td className="p-2">{pago.factura_numero}</td>
                          <td className="p-2 text-right tabular-nums text-green-600 font-medium">
                            {formatCurrency(pago.monto)}
                          </td>
                          <td className="p-2">
                            <Badge variant="outline">{pago.metodo_pago}</Badge>
                          </td>
                          <td className="p-2 text-center">
                            {compsCount > 0 ? (
                              <Button
                                variant="ghost"
                                size="sm"
                                onClick={() => onVerComprobantes(pago)}
                                className="h-7 px-2 gap-1"
                                title={`Ver ${compsCount} comprobante(s)`}
                              >
                                <Paperclip className="w-3 h-3" />
                                <span className="text-xs">{compsCount}</span>
                              </Button>
                            ) : (
                              <span className="text-xs text-muted-foreground">—</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cerrar</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
